import React, { useState, useEffect } from 'react';
import {
  MdBusiness,
  MdHome,
  MdPersonAdd,
  MdPeople,
  MdDeviceHub,
  MdRepeat,
  MdStore,
  MdLocationCity,
  MdDateRange,
  MdDescription,
  MdSettingsInputComponent,
  MdImportantDevices,
  MdRecordVoiceOver,
  MdPhonelinkSetup,
  MdInsertChart,
} from 'react-icons/md';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Logo from '~/assets/images/logo_branco.png';
import history from '~/services/history';
import { Container, Itens, Item, Top } from './styles';

export default function Sidebar() {
  const user = useSelector(state => state.user.profile);
  const [menuSetup, setMenuSetup] = useState([]);
  const [url, setUrl] = useState('/chat');

  const [menusChat, setMenusChat] = useState([
    {
      id: 3,
      title: 'Chat',
      active: false,
      icon: <MdPhonelinkSetup size={16} color="#FFF" />,
      url: '/chat',
      menu: 'Chat',
    },
  ]);

  const menuVisible = useSelector(state => state.dash.menu);
  const [menusGerais, setMenusGerais] = useState([]);

  useEffect(() => {
    const dadosUrl = window.location.pathname.split('/');
    setUrl(`/${dadosUrl[1]}`);
  }, []);

  useEffect(() => {
    function menus() {
      if (user.provider === '1') {
        const data = [
          {
            id: 1,
            title: 'Início',
            active: url === '/dashboard',
            icon: <MdHome size={16} color="#FFF" />,
            url: '/dashboard',
            menu: 'Gerais',
          },
          {
            id: 2,
            title: 'Usuários',
            active:
              url === '/user' || url === '/user-create' || url === '/user-edit',
            icon: <MdPersonAdd size={16} color="#FFF" />,
            url: '/user',
            menu: 'Gerais',
          },
          {
            id: 3,
            title: 'Leads',
            active: url === '/leads' || url === '/create-lead',
            icon: <MdDeviceHub size={16} color="#FFF" />,
            url: '/leads',
            menu: 'Gerais',
          },
          {
            id: 4,
            title: 'Temperaturas',
            active:
              url === '/temperatura' ||
              url === '/temperatura-create' ||
              url === '/temperatura-edit',
            icon: <MdSettingsInputComponent size={16} color="#FFF" />,
            url: '/temperatura',
            menu: 'Gerais',
          },
          {
            id: 5,
            title: 'Atendimentos',
            active: url === '/atendimento' || url === '/atendimento-create',
            icon: <MdRecordVoiceOver size={16} color="#FFF" />,
            url: '/atendimento',
            menu: 'Gerais',
          },
          {
            id: 6,
            title: 'Atividades',
            active: url === '/atividades',
            icon: <MdInsertChart size={16} color="#FFF" />,
            url: '/atividades',
            menu: 'Gerais',
          },
          // {
          //   id: 7,
          //   title: 'Relatório',
          //   active: url === '/relatorio',
          //   icon: <MdDescription size={16} color="#FFF" />,
          //   url: '/relatorio',
          //   menu: 'Gerais',
          // },
          // {
          //   id: 8,
          //   title: 'Relatório de e-mails',
          //   active: url === '/relatorio-email',
          //   icon: <MdDescription size={16} color="#FFF" />,
          //   url: '/relatorio-email',
          //   menu: 'Gerais',
          // },
        ];

        setMenusGerais(data);
      } else if (user.provider === '2') {
        const data = [
          {
            id: 1,
            title: 'Início',
            active: url === '/dashboard',
            icon: <MdHome size={16} color="#FFF" />,
            url: '/dashboard',
            menu: 'Gerais',
          },
          {
            id: 2,
            title: 'Times',
            active:
              url === '/times' ||
              url === '/times-create' ||
              url === '/times-edit',
            icon: <MdPeople size={16} color="#FFF" />,
            url: '/times',
            menu: 'Gerais',
          },
          {
            id: 3,
            title: 'Usuários',
            active:
              url === '/user' || url === '/user-create' || url === '/user-edit',
            icon: <MdPersonAdd size={16} color="#FFF" />,
            url: '/user',
            menu: 'Gerais',
          },
          {
            id: 4,
            title: 'Produtos',
            active:
              url === '/produto' ||
              url === '/produto-create' ||
              url === '/produto-edit' ||
              url === '/questionario-create' ||
              url === '/questionario-edit' ||
              url === '/resposta-create' ||
              url === '/resposta-edit' ||
              url === '/padrao-create',
            icon: <MdStore size={16} color="#FFF" />,
            url: '/produto',
            menu: 'Gerais',
          },
          {
            id: 5,
            title: 'Leads',
            active: url === '/leads' || url === '/create-lead',
            icon: <MdDeviceHub size={16} color="#FFF" />,
            url: '/leads',
            menu: 'Gerais',
          },
          {
            id: 6,
            title: 'Temperaturas',
            active:
              url === '/temperatura' ||
              url === '/temperatura-create' ||
              url === '/temperatura-edit',
            icon: <MdSettingsInputComponent size={16} color="#FFF" />,
            url: '/temperatura',
            menu: 'Gerais',
          },
          {
            id: 7,
            title: 'Atendimentos',
            active: url === '/atendimento' || url === '/atendimento-create',
            icon: <MdRecordVoiceOver size={16} color="#FFF" />,
            url: '/atendimento',
            menu: 'Gerais',
          },
          {
            id: 8,
            title: 'Atividades',
            active: url === '/atividades',
            icon: <MdInsertChart size={16} color="#FFF" />,
            url: '/atividades',
            menu: 'Gerais',
          },
          // {
          //   id: 9,
          //   title: 'Relatório',
          //   active: url === '/relatorio',
          //   icon: <MdDescription size={16} color="#FFF" />,
          //   url: '/relatorio',
          //   menu: 'Gerais',
          // },
          // {
          //   id: 10,
          //   title: 'Relatório de e-mails',
          //   active: url === '/relatorio-email',
          //   icon: <MdDescription size={16} color="#FFF" />,
          //   url: '/relatorio-email',
          //   menu: 'Gerais',
          // },
        ];

        setMenusGerais(data);
      } else if (user.provider === '3') {
        const data = [
          {
            id: 1,
            title: 'Início',
            active: url === '/dashboard',
            icon: <MdHome size={16} color="#FFF" />,
            url: '/dashboard',
            menu: 'Gerais',
          },
          {
            id: 3,
            title: 'Leads',
            active: url === '/leads' || url === '/create-lead',
            icon: <MdDeviceHub size={16} color="#FFF" />,
            url: '/leads',
            menu: 'Gerais',
          },
          {
            id: 4,
            title: 'Atendimentos',
            active: url === '/atendimento' || url === '/atendimento-create',
            icon: <MdRecordVoiceOver size={16} color="#FFF" />,
            url: '/atendimento',
            menu: 'Gerais',
          },
          {
            id: 5,
            title: 'Atividades',
            active: url === '/atividades',
            icon: <MdInsertChart size={16} color="#FFF" />,
            url: '/atividades',
            menu: 'Gerais',
          },
        ];
        setMenusGerais(data);
      } else if (user.provider === '4') {
        const data = [
          {
            id: 1,
            title: 'Início',
            active: url === '/dashboard',
            icon: <MdHome size={16} color="#FFF" />,
            url: '/dashboard',
            menu: 'Gerais',
          },
          {
            id: 2,
            title: 'Cidades',
            active: url === '/cidades',
            icon: <MdLocationCity size={16} color="#FFF" />,
            url: '/cidades',
            menu: 'Gerais',
          },
          {
            id: 3,
            title: 'Incorporadoras',
            active:
              url === '/incorporadora' ||
              url === '/incorporadora-create' ||
              url === '/incorporadora-edit' ||
              url === '/cancelamento',
            icon: <MdBusiness size={16} color="#FFF" />,
            url: '/incorporadora',
            menu: 'Gerais',
          },
          {
            id: 4,
            title: 'Times',
            active:
              url === '/times' ||
              url === '/times-create' ||
              url === '/times-edit',
            icon: <MdPeople size={16} color="#FFF" />,
            url: '/times',
            menu: 'Gerais',
          },
          {
            id: 5,
            title: 'Usuários',
            active:
              url === '/user' || url === '/user-create' || url === '/user-edit',
            icon: <MdPersonAdd size={16} color="#FFF" />,
            url: '/user',
            menu: 'Gerais',
          },
          {
            id: 6,
            title: 'Cadências',
            active:
              url === '/cadencia' ||
              url === '/cadencia-create' ||
              url === '/cadencia-edit' ||
              url === '/tentativa-create' ||
              url === '/tentativa-edit',
            icon: <MdRepeat size={16} color="#FFF" />,
            url: '/cadencia',
            menu: 'Gerais',
          },
          {
            id: 7,
            title: 'Integrações',
            active:
              url === '/integracao' ||
              url === '/integracao-new' ||
              url === '/integracao-edit',
            icon: <MdImportantDevices size={16} color="#FFF" />,
            url: '/integracao',
            menu: 'Gerais',
          },
          {
            id: 8,
            title: 'Produtos',
            active:
              url === '/produto' ||
              url === '/produto-create' ||
              url === '/produto-edit' ||
              url === '/questionario-create' ||
              url === '/questionario-edit' ||
              url === '/resposta-create' ||
              url === '/resposta-edit' ||
              url === '/padrao-create',
            icon: <MdStore size={16} color="#FFF" />,
            url: '/produto',
            menu: 'Gerais',
          },
          {
            id: 9,
            title: 'Leads',
            active: url === '/leads' || url === '/create-lead',
            icon: <MdDeviceHub size={16} color="#FFF" />,
            url: '/leads',
            menu: 'Gerais',
          },
          {
            id: 10,
            title: 'Temperaturas',
            active:
              url === '/temperatura' ||
              url === '/temperatura-create' ||
              url === '/temperatura-edit',
            icon: <MdSettingsInputComponent size={16} color="#FFF" />,
            url: '/temperatura',
            menu: 'Gerais',
          },
          {
            id: 11,
            title: 'Atendimentos',
            active: url === '/atendimento' || url === '/atendimento-create',
            icon: <MdRecordVoiceOver size={16} color="#FFF" />,
            url: '/atendimento',
            menu: 'Gerais',
          },
          {
            id: 12,
            title: 'Atividades',
            active: url === '/atividades',
            icon: <MdInsertChart size={16} color="#FFF" />,
            url: '/atividades',
            menu: 'Gerais',
          },
          // {
          //   id: 13,
          //   title: 'Relatório',
          //   active: url === '/relatorio',
          //   icon: <MdDescription size={16} color="#FFF" />,
          //   url: '/relatorio',
          //   menu: 'Gerais',
          // },
          // {
          //   id: 14,
          //   title: 'Relatório de e-mails',
          //   active: url === '/relatorio-email',
          //   icon: <MdDescription size={16} color="#FFF" />,
          //   url: '/relatorio-email',
          //   menu: 'Gerais',
          // },
          {
            id: 15,
            title: 'Mensagens',
            active: url === '/mensagem',
            icon: <MdDescription size={16} color="#FFF" />,
            url: '/mensagem',
            menu: 'Gerais',
          },
          // {
          //   id: 16,
          //   title: 'Relatorios Gerais',
          //   active: url === '/relatorio-gerais',
          //   icon: <MdDescription size={16} color="#FFF" />,
          //   url: '/relatorio-gerais',
          //   menu: 'Gerais',
          // },
        ];
        const setup = [
          {
            id: 1,
            title: 'Agendamentos',
            active: url === '/agendamentos',
            icon: <MdDateRange size={16} color="#FFF" />,
            url: '/agendamentos',
            menu: 'Setup',
          },
        ];
        setMenuSetup(setup);
        setMenusGerais(data);
      }
    }
    menus();
  }, [url, user, user.provider]);

  function handlerNav(url, menuType) {
    if (menuType === 'Gerais') {
      const data = menusGerais.map(menu => {
        menu.active = false;
        if (menu.url === url) {
          menu.active = true;
        }
        return {
          ...menu,
        };
      });
      const dats = menusChat.map(menu => {
        menu.active = false;
        return {
          ...menu,
        };
      });
      const datc = menuSetup.map(menu => {
        menu.active = false;
        return {
          ...menu,
        };
      });
      setMenuSetup(datc);
      setMenusChat(dats);
      setMenusGerais(data);
    } else if (menuType === 'Setup') {
      const data = menuSetup.map(menu => {
        menu.active = false;
        if (menu.url === url) {
          menu.active = true;
        }
        return {
          ...menu,
        };
      });
      const dats = menusGerais.map(menu => {
        menu.active = false;
        return {
          ...menu,
        };
      });
      const datc = menusChat.map(menu => {
        menu.active = false;
        return {
          ...menu,
        };
      });
      setMenusChat(datc);
      setMenusGerais(dats);
      setMenuSetup(data);
    } else if (menuType === 'Chat') {
      const data = menusChat.map(menu => {
        menu.active = false;
        if (menu.url === url) {
          menu.active = true;
        }
        return {
          ...menu,
        };
      });
      const dats = menusGerais.map(menu => {
        menu.active = false;
        return {
          ...menu,
        };
      });
      const datc = menuSetup.map(menu => {
        menu.active = false;
        return {
          ...menu,
        };
      });
      setMenuSetup(datc);
      setMenusGerais(dats);
      setMenusChat(data);
    }

    history.push(`${url}`);
  }

  return (
    <Container menus={menuVisible}>
      <Top>
        <Link to="/dashboard">
          <img src={Logo} alt="" />
        </Link>
      </Top>
      <Itens>
        <span>Geral</span>
        {menusGerais.map(menu => (
          <Item
            key={menu.id}
            active={menu.active}
            onClick={() => handlerNav(menu.url, menu.menu)}
          >
            {menu.icon}
            <span>{menu.title}</span>
          </Item>
        ))}
        <span>ChatBot</span>
        {menusChat.map(menu => (
          <Item
            key={menu.id}
            active={menu.active}
            onClick={() => handlerNav(menu.url, menu.menu)}
          >
            {menu.icon}
            <span>{menu.title}</span>
          </Item>
        ))}
        {user.provider === '4' && (
          <>
            <span>Sistema</span>
            {menuSetup.map(menu => (
              <Item
                key={menu.id}
                active={menu.active}
                onClick={() => handlerNav(menu.url, menu.menu)}
              >
                {menu.icon}
                <span>{menu.title}</span>
              </Item>
            ))}
          </>
        )}
      </Itens>
    </Container>
  );
}
